<script>
    import categories from "../stores/categories";
    import {createEventDispatcher} from 'svelte';
    import {JSONClone, findNode, backPath, slugify} from "../lib/lib";
    import CategoryAutocomplete from "./CategoryAutocomplete.svelte";
    import CheckboxControl from '../controls/CheckboxControl.svelte';
    import {setFocusTo} from "../lib/lib";
    import {categorySave} from "../lib/requests";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';

    const dispatch = createEventDispatcher();

    export let category;

    let editedCategory = null;
    let parentsPath = '';
    let categoryTitle = '';
    let aliasPath = '';

    const onClick = () => {
        if (editedCategory !== null) {
            return;
        }
        $categories.selected_id = category.id;
    }

    const onToggle = () => {
        if (category.children.length > 0) {
            category.expanded = !category.expanded;
        }
        onClick();
    }

    const onNameClick = (event) => {
        if (event.ctrlKey && category.children.length > 0) {
            onToggle();
        }
    }

    const onNameDoubleClick = () => {
        dispatch('edit', category);
    }


    const onCancel = () => {
        if (editedCategory.id === 0) {
            // remove child from parent
            let parent = findNode(editedCategory.parent_id, $categories.tree);
            parent.children = parent.children.filter(x => x.id !== editedCategory.id);
            $categories.tree = $categories.tree;
        }
        $categories.edit_id = null;
        editedCategory = null;
    }

    const onSave = async () => {
        if (editedCategory.name_el.trim().length == 0 || editedCategory.name_en.trim().length == 0) {
            app_alert.show('error', "Πληκτρολογήστε το όνομα της κατηγορίας και στις 2 γλώσσες!");
            return;
        }

        if (editedCategory.alias_parent_id > 0 && (editedCategory.alias_parent_id == editedCategory.id || editedCategory.alias_parent_id == editedCategory.parent_id)) {
            app_alert.show('error', "Η 2η κατηγορία που θα εμφανίζεται δεν είναι έγκυρη!");
            return;
        }

        // Parent has change
        let parent = null;
        if (category.parent_id !== editedCategory.parent_id) {
            // remove category from parent
            parent = findNode(category.parent_id, $categories.tree);
            parent.children = parent.children.filter(x => x.id !== category.id);
            // add category on new parent
            parent = findNode(editedCategory.parent_id, $categories.tree);
            parent.children = [...parent.children, editedCategory];
        }

        const [err, res] = await categorySave(editedCategory);

        if (err) {
            alert('error ' + err);
            return;
        }

        editedCategory.id = res.category.id;
        category.id = editedCategory.id;
        category.name_el = editedCategory.name_el;
        category.name_en = editedCategory.name_en;
        category.parent_id = editedCategory.parent_id;
        category.alias_parent_id = editedCategory.alias_parent_id;
        category.slug = editedCategory.slug;
        category.is_deprecated = editedCategory.is_deprecated;
        $categories.edit_id = null;
        editedCategory = null;
        $categories.tree = $categories.tree;
        $categories.selected_id = category.id;

        success.show("Η κατηγορία ενημερώθηκε.");
    }

    const onNameFocusOut = event => {
        editedCategory.name_el = editedCategory.name_el.trim();
        editedCategory.name_en = editedCategory.name_en != null ? editedCategory.name_en.trim() : '';

        if (editedCategory.slug.trim().length == 0) {
            if (editedCategory.name_en) {
                editedCategory.slug = slugify(editedCategory.name_en);
            } else {
                editedCategory.slug = slugify(editedCategory.name_el);
            }
        }
    }

    $:{
        if (category) {
            if (editedCategory === null && $categories.edit_id === category.id) {
                editedCategory = JSONClone(category);
                setFocusTo('cat-name-el');
            }

            categoryTitle = "id: " + category.id + " - level: " + category.level;

            if (category.slug == null) {
                category.slug = '';
            }

            if (category.alias_parent_id > 0 && aliasPath == '') {
                aliasPath = backPath(category.alias_parent_id, $categories.tree);
            } else {
                if (category.alias_parent_id == 0 || category.alias_parent_id == null) {
                    aliasPath = '';
                }
            }
        }
    }
</script>

{#if category}
    <div class="node-group level-{ category.level }" id="cat-item-{ category.id }"
         on:click|preventDefault|stopPropagation="{ onClick }">
        <div class="node" class:selected={ category.id === $categories.selected_id }>
            {#if category.children.length > 0}
                <div class="toggle" on:click|preventDefault|stopPropagation="{ onToggle }">
                    {#if category.expanded}
                        <i class="fa fa-chevron-down"></i>
                    {:else}
                        <i class="fa fa-chevron-right"></i>
                    {/if}
                </div>
            {/if}
            {#if editedCategory !== null}
                <div class="edit-panel" style="max-width: 500px;">
                    <div class="edit-panel-heading">
                        {#if !editedCategory.name_el}
                            Νέα κατηγορία
                        {:else}
                            { editedCategory.name_el }
                        {/if}
                    </div>
                    <div class="edit-panel-body">
                        <div class="row">
                            <div class="col-md-6">
                                <label>Id: { editedCategory.id > 0 ? editedCategory.id : 'ΝΕΟ' }</label>
                            </div>
                        </div>
                        <hr style="margin-top: none">
                        <div class="form-group">
                            <label>Όνομα</label>
                            <input type="text" class="form-control" id="cat-name-el"
                                   bind:value="{ editedCategory.name_el }" on:focusout={onNameFocusOut}>
                        </div>
                        <div class="form-group">
                            <label>Name</label>
                            <input type="text" class="form-control" id="cat-name-en"
                                   bind:value="{ editedCategory.name_en }" on:focusout={onNameFocusOut}>
                        </div>
                        <div class="form-group">
                            <label>Link</label>
                            <input type="text" class="form-control" id="cat-slug" bind:value="{ editedCategory.slug }">
                        </div>
                        {#if editedCategory.children.length === 0}
                            <div class="form-group">
                                <label>Εμφάνιση επίσης στην κατηγορία</label>
                                <CategoryAutocomplete bind:categoryId="{ editedCategory.alias_parent_id }"/>
                            </div>
                        {/if}

                        {#if editedCategory.parent_id > 0}
                            <div class="form-group">
                                <label>Μαμά</label>
                                <CategoryAutocomplete bind:categoryId="{ editedCategory.parent_id }"/>
                            </div>
                        {/if}
                        <div class="form-group">
                            <CheckboxControl label="Καταργήθηκε" bind:checked={ editedCategory.is_deprecated }/>
                        </div>
                        <div class="text-right">
                            <button class="btn btn-primary btn-md" on:click="{ onSave }">Ενημέρωση</button>
                            <button class="btn btn-default btn-md" on:click="{ onCancel }">Ακύρωση</button>
                        </div>
                    </div>
                </div>
            {:else}
                <div class="name" on:click="{ onNameClick }"
                     on:dblclick|preventDefault|stopPropagation="{ onNameDoubleClick }">
                    <span class:not-nactive="{ category.is_deprecated == 1 }" title="{ categoryTitle }">
                        { category.name_el }
                    </span>
                    {#if parentsPath}
                        <div class="marked-path">
                            { parentsPath }
                        </div>
                    {/if}
                    {#if category.name_old != null && category.name_old !== category.name_el}
                        <span class="old-name">
                            αλλαγή από: {category.name_old}
                        </span>
                    {/if}
                    {#if aliasPath != ''}
                        <span class="alias-name">
                            {category.alias_parent_id} - {aliasPath}
                        </span>
                    {/if}
                </div>
                <div class="slug">
                    {category.slug}
                </div>
            {/if}
        </div>

        {#if category.expanded}
            <div class="children">
                {#each category.children as child}
                    <svelte:self category="{ child }"
                                 on:cancel_edit
                                 on:edit
                    />
                {/each}
            </div>
        {/if}
    </div>
{/if}

<style>
    .slug {
        float: right;
        color: #878787;
        padding: 5px;
    }

    .old-name {
        display: block;
        font-size: 12px;
        color: red;
    }

    .alias-name {
        display: block;
        font-size: 12px;
        color: green;
    }
</style>